import { render, staticRenderFns } from "./SubselectionItem.vue?vue&type=template&id=4baac5b6&scoped=true&"
import script from "./SubselectionItem.vue?vue&type=script&lang=js&"
export * from "./SubselectionItem.vue?vue&type=script&lang=js&"
import style0 from "./SubselectionItem.vue?vue&type=style&index=0&id=4baac5b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baac5b6",
  null
  
)

export default component.exports